import { render, staticRenderFns } from "./FetchData.vue?vue&type=template&id=06c7690c&"
import script from "./FetchData.vue?vue&type=script&lang=js&"
export * from "./FetchData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports